import { createBlot } from './quoteBolt';
import chapterColors from '../../../../ConfigFiles/chapter_colors';

//  File where all blots used for the diagnosis text editor are registered

Object.entries(chapterColors).forEach(([blotName, color]) => {
    createBlot(color, blotName, 'span');
});

//  Important: This file is only imported for its side effects (Quill.register)